module["exports"] = [
  "+90-###-###-##-##",
  "+90-###-###-#-###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/tr/phone_number/formats.js
 ** module id = 1115
 ** module chunks = 0
 **/